import { Injectable } from '@angular/core';
import { DocumentMediaModel } from '@phdsoft/common';
import { DocumentsSearchService } from 'src/app/template/documents/documents-search/documents-search.service';
import { MatDialog } from '@angular/material/dialog';
import { DocumentsListService } from 'src/app/template/documents/documents-list/documents-list.service';
import { Asset } from 'src/app/platform/busines-data/Framework/Asset';
import { DocumentResource } from 'src/app/platform/busines-data/ResourceElements/document';
import { Modes } from 'src/app/platform/busines-data/Framework/mode';

@Injectable({ providedIn: 'root' })
export class GraphicsRenderDocuments {

  constructor(
    private documentsSearchService: DocumentsSearchService,
    private readonly dialog: MatDialog,
    private documentsListService: DocumentsListService,
  ) { }

  public populateDocumentCollection(asset: Asset, documents: DocumentMediaModel[]): void {
    const checkListDocuments = []
    const elementDocuments = {}
    const sectionDocuments = []
    const regionsDocuments = []
    const assetDocuments = []

    for (const document of documents) {
      if (document.Keywords?.includes("CHECKLIST")) {
        checkListDocuments.push(document)
      }
      else if (document.ElementId) {
        elementDocuments[document.ElementId] = document;
      }
      else if (document.SectionId || (document.SectionIds && document.SectionIds.length > 0)) {
        sectionDocuments.push(document);
      }
      else if (document.RegionId || (document.RegionIds && document.RegionIds.length > 0)) {
        regionsDocuments.push(document);
      }
      else {
        assetDocuments.push(document);
      }
    }

    this.addDocuments(asset, assetDocuments, 'MODEL');
    this.addDocuments(asset, regionsDocuments, 'REGIONS');
    this.addDocuments(asset, sectionDocuments, 'SECTIONS');
  }

  private addDocuments(asset: Asset, documents: Array<DocumentMediaModel>, mode: Modes): void {
    for (const assetDocument of documents) {
      asset.DocumentCollection.addDocument(
        new DocumentResource(
          assetDocument, mode, this.documentsSearchService,
          this.documentsListService, this.dialog
        )
      );
    }
  }
}
